import { LeadsAppointmentScheduled } from "./LeadsAppointmentScheduled";
import { LeadsMissedAppointments } from "./LeadsMissedAppointments";
import { NurtureStages } from "./NurtureStages";
import { StopReviveStages } from "./StopReviveStage";

export const StageMapping = () => {
  return (
    <div className="flex flex-col flex-1">
      <div className="flex items-center justify-between py-5 pl-10 pr-4 font-medium">
        Map Stages
      </div>
      <div>
        <p className="px-10 py-5 border-b border-black/20 text-[12px] font-medium text-[#B98BE6] bg-primary/10">
          Select how you want to update Follow Up Boss, once a lead’s stage has
          changed.
        </p>
        <p className="px-10 py-5 border-b border-black/20 text-[12px] bg-primary/10">
          Set Custom Working Hours for this Campaign
        </p>
        <div className="flex flex-col gap-y-1">
          <LeadsAppointmentScheduled />
          <LeadsMissedAppointments />
          <NurtureStages />
          <StopReviveStages />
        </div>
      </div>
    </div>
  );
};
